import { render, staticRenderFns } from "./InvoicesEditing.vue?vue&type=template&id=56461289&scoped=true"
import script from "./InvoicesEditing.vue?vue&type=script&lang=js"
export * from "./InvoicesEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56461289",
  null
  
)

export default component.exports